// import React from 'react'

import { ThemeMode } from '#/enum'
import { useMultiTabsContext } from '@/layouts/dashboard/multi-tabs/providers/multi-tabs-provider'
import { useSettings } from '@/store/settingStore'
import { BarChartOutlined, CalendarOutlined, FileOutlined, HomeOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'
import { RiPriceTag2Fill } from 'react-icons/ri'
import { TbMoneybag } from 'react-icons/tb'
import { useNavigate, useSearchParams } from 'react-router'
import { MdErrorOutline } from 'react-icons/md'

const PaymentFailedErrorScreen = () => {
  const navigate = useNavigate();
  const { themeMode } = useSettings();
  const { closeAll } = useMultiTabsContext();

    const [searchParams] = useSearchParams();
    const plan = searchParams.get("plan");
    const price = searchParams.get("price");
    const credits = searchParams.get("credits");
    const billingCycle = searchParams.get("billingCycle");

  return (
    <div className='w-full flex flex-col items-center justify-center gap-3 h-full bg-[#F8FAFC] dark:bg-[#020617]'>

      {/* Tick */}
      <div className='w-[80px] h-[80px] rounded-full bg-error-lighter flex items-center justify-center'>
        <MdErrorOutline style={{fontSize:"30px"}} className="text-error-dark"/>
      </div>

      <h1 className='font-bold text-3xl mt-2 dark:text-white'>Something went wrong!</h1>

      {/* <h2 className='font-bold text-error-dark text-[16px]'>Welcome to {plan?.charAt(0).toUpperCase() + plan?.slice(1)} Plan</h2> */}

      <span className='text-gray-600 dark:text-gray-400 text-center w-[60%] font-semibold mt-2'>Your payment of {price} was unsuccessful. </span>


      {/* Box Section */}
      <div className='w-[70%] p-4 bg-[#FFFAFC] dark:bg-[#0f172a] border border-[#C4123020] dark:border-[#C4123040] mt-4 rounded-md flex'>

        <div className='border-r-[1px] border-[#C4123020] dark:border-[#C4123040] w-1/4 p-4 flex gap-10'>
            <div className='w-[40px] h-[40px] rounded-md flex items-center justify-center' style={{backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.05)"}}>
                <BarChartOutlined style={{fontSize:"24px",color: "#C41230"}}/>
            </div>
            <div className='flex flex-col gap-y-3'>
              <span className='text-gray-700 dark:text-gray-400 font-semibold'>Plan</span>
              <span className='font-bold capitalize dark:text-white'>{plan}</span>
            </div>
        </div>

         <div className='border-r-[1px] border-[#C4123020] dark:border-[#C4123040] w-1/4 p-4 flex gap-10'>
            <div className='w-[40px] h-[40px] rounded-md flex items-center justify-center' style={{backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.05)"}}>
                <TbMoneybag style={{fontSize:"24px",color: "#C41230"}}/>
            </div>
            <div className='flex flex-col gap-y-3'>
              <span className='text-gray-700 dark:text-gray-400 font-semibold'>Credits</span>
              <span className='font-bold text-xl dark:text-white'>{credits}</span>
            </div>
        </div>

       <div className='border-r-[1px] border-[#C4123020] dark:border-[#C4123040] w-1/4 p-4 flex gap-10'>
            <div className='w-[40px] h-[40px] rounded-md flex items-center justify-center' style={{backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.05)"}}>
                <RiPriceTag2Fill style={{fontSize:"24px",color: "#C41230"}}/>
            </div>
            <div className='flex flex-col gap-y-3'>
              <span className='text-gray-700 dark:text-gray-400 font-semibold'>Amount Failed</span>
              <span className='font-bold text-xl dark:text-white'>{price}</span>
            </div>
        </div>

         <div className=' w-1/4 p-4 flex gap-10'>
            <div className='w-[40px] h-[40px] rounded-md flex items-center justify-center' style={{backgroundColor: themeMode === ThemeMode.Dark ? "rgba(196,18,48,0.1)" : "rgba(196,18,48,0.05)"}}>
                <CalendarOutlined style={{fontSize:"24px",color: "#C41230"}}/>
            </div>
            <div className='flex flex-col gap-y-3'>
              <span className='text-gray-700 dark:text-gray-400 font-semibold'>Billing Cycle</span>
              <span className='font-bold text-xl capitalize dark:text-white'>{billingCycle}</span>
            </div>
        </div>

      </div>

      {/* <span className='mt-2 text-gray-600 font-semibold text-sm'>A receipt has been sent to sabarisshan007@gmail.com</span> */}

      <div className='flex gap-3 items-center mt-4'>
        <Button icon={<HomeOutlined/>} size='large' type='primary' className='px-4' style={{width: "200px", fontWeight:"600"}} onClick={()=>closeAll()}>Go to Home</Button>
        {/* <Button icon={<FileOutlined/>} size='large' className='dark:bg-transparent dark:hover:!bg-[#C41230]/20' style={{width: "200px", fontWeight:"600", borderColor:"#C41230",color:"#C41230"}} onClick={()=>navigate("/dashboard/upgrade-plan")}>View Billing</Button> */}
      </div>

    </div>
  )
}

export default PaymentFailedErrorScreen